import { ButtonBase, Chip, CircularProgress, Grid, IconButton, List, ListItemButton, ListSubheader, ThemeProvider, createTheme, styled } from '@mui/material';
import { React, useState, useEffect } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import BusinessIcon from '@mui/icons-material/Business';
import { PaginationNavigation } from '../funtions';

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  'position': 'relative',
  'borderRadius': '1vw',
  'transition': '0.1s',
  '&:hover, &.Mui-focusVisible': {
    'zIndex': 1,
    'backgroundColor': 'rgb(254, 254, 255, 0.05)',
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      border: '4px solid currentColor',
    },
  },
}));

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function formatABN(abn) {
  if (abn == 'NOT PROVIDED') {
    return abn;
  }

  // Remove any non-digit characters in case the input is not clean
  let str = abn.replace(/\D/g, '');

  // Check if the input is exactly 11 digits, if not, handle as needed
  if (str.length !== 11) {
    console.error('Invalid ABN: ABN must be exactly 11 digits');
    return null;
  }

  // Insert spaces to format as ABN
  return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
}

export default ({ customerData, openAssignmentModal, onChangedABN, openDetailModalHandler, currentPage, previousPageHandler, nextPageHandler, isLoading }) => {
  const [
    tableData,
    setTableData,
  ] = useState(customerData);
  const itemsPerPage = 12;

  let indexOfLastItem = currentPage * itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [
    currentItems,
    setCurrentitems,
  ] = useState(tableData.slice(indexOfFirstItem, indexOfLastItem));

  // Page change handlers
  const nextPage = () => {
    if (currentPage < Math.ceil(tableData.length / itemsPerPage)) {
      nextPageHandler();
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      previousPageHandler();
    }
  };

  useEffect(() => {
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(tableData.slice(indexOfFirstItem, indexOfLastItem));
  }, [
    currentPage,
    tableData,
  ]);

  useEffect(() => {
    setTableData(customerData);
  }, [customerData]);

  return (
    <>

      <div style={{ lineHeight: '2vw', paddingLeft: '0', marginRight: '0', borderRadius: '1vw', textAlign: 'left' }}>

        { currentItems.length != 0 && (
          <Grid id="request-folder-view" container spacing={2}>
            { !isLoading && currentItems.map((row, index) => {
              return (
                <Grid key={`request-folder-view-item-${row.client_abn}`} id={`request-folder-view-item-${row.client_abn}`} item xs={4} spacing={1}>
                  <ButtonBase style={{ width: '100%', textAlign: 'left', color: 'black', borderRadius: '1vw', overflow: 'hidden' }}>
                    <div
                      style={{ width: '100%', backgroundColor: 'rgb(254, 254, 255, 0.55)', cursor: 'pointer', border: '0.05vw solid rgb(254, 254, 255, 0)' }}
                      onClick={() => { openDetailModalHandler(row); }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <IconButton style={{ margin: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.7)' }} disabled>
                          <BusinessIcon style={{ margin: '0.5vw', fontSize: '2vw', color: 'rgb(0, 15, 30, 0.7)' }} />
                        </IconButton>
                        <div style={{ flex: 1, padding: '0.5vw', paddingLeft: '0', display: 'flex', flexDirection: 'column', overflow: 'hidden', marginRight: '0.5vw' }}>
                          <p style={{ fontSize: '0.9vw', margin: 0, lineHeight: '1.5vw', overflowX: 'hidden', whiteSpace: 'nowrap', fontWeight: '600', color: 'rgb(0, 15, 30, 0.7)', marginBottom: '0.3vw', width: '100%' }}>{row.clientName}</p>
                          <p style={{ fontSize: '0.75vw', lineHeight: '1.5vw', margin: 0, fontWeight: '400', color: 'rgb(0, 15, 30, 0.3)' }}>{formatABN(row.ABN)}</p>

                        </div>
                        <div style={{ alignSelf: 'flex-start', margin: '0.5vw 1vw 0 0' }}>
                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{row.statusDetail ? row.statusDetail : 'Unknown Message'}</Tooltip>}>
                            <span className="d-inline-block">
                              <ThemeProvider theme={darkTheme}>
                                <Chip size="small" style={{ fontSize: '0.6vw', lineHeight: '1vw', padding: '0 0.1vw', height: '1.5vw', backgroundColor: 'rgb(254, 254, 255, 0.9)', color: 'white', fontWeight: '500', color: 'rgb(0, 15, 30, 0.7)' }} label={String(row.status).toUpperCase()} />

                              </ThemeProvider>

                              {/* </span> */}
                            </span>
                          </OverlayTrigger>
                        </div>
                      </div>
                      {/* <div style={{padding: '1.3vw', paddingTop: '0'}}>
                                            <p style={{fontSize: '0.8vw', lineHeight: '1.5vw', margin: 0, fontWeight: '500', color: 'rgb(254, 254, 255, 0.9)'}}><span style={{color: 'rgb(254, 254, 255, 0.6)'}}>Period:</span> {period}</p>
                                            <p style={{fontSize: '0.8vw', lineHeight: '1.5vw', margin: 0, fontWeight: '500', color: 'rgb(254, 254, 255, 0.85)'}}><span style={{color: 'rgb(254, 254, 255, 0.6)'}}>Latest Version:</span> {row.latest_version}</p>

                                        </div> */}
                    </div>
                  </ButtonBase>
                </Grid>
              );
            })}
          </Grid>
        )}

        { currentItems.length == 0 && !isLoading && (
          <>
            <div style={{ textAlign: 'center', borderRadius: '1vw', padding: '3vw', backgroundColor: 'rgb(255, 255, 255, 0.6)' }}>
              <p style={{ fontSize: '1vw', margin: '0', marginBottom: '0.5vw', color: 'rgb(0, 15, 30, 0.8)' }}>No Client Found</p>
              <p style={{ fontSize: '0.8vw', margin: '0', color: 'rgb(0, 15, 30, 0.7)' }}>Click '+' button to add a new client</p>
            </div>
          </>
        ) }

        { currentItems.length == 0 && isLoading && (
          <>
            <div style={{ textAlign: 'center', borderRadius: '1vw', padding: '3vw', backgroundColor: 'rgb(255, 255, 255, 0.6)' }}>
              <div style={{ flex: 1 }}><p style={{ textAlign: 'center', marginTop: '30px', marginBottom: '30px' }}><CircularProgress color="grey" /></p></div>
            </div>
          </>
        ) }
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1vw' }}>
        <div style={{ flex: 1, alignSelf: 'center' }}>
          <p style={{ color: 'rgb(0,15,30, 0.6)', fontSize: '0.85vw', marginLeft: '0.5vw', marginBottom: 0 }}>
            Showing
            {indexOfFirstItem + 1}
            {' '}
            to
            {tableData.length > indexOfLastItem ? indexOfLastItem : tableData.length}
            {' '}
            of
            {tableData.length}
            {' '}
            entries
          </p>
        </div>

        {/* arrow buttons */}
        <PaginationNavigation onNextPage={nextPage} onPrevPage={prevPage} />

      </div>

    </>
  );
};
